import { at, hydrateMappedForm, serializeMappedForm } from "./formAdapter";

const fields = [
  ["codigo", "identidad.codigo", "text"],
  ["primerNombre", "identidad.primerNombre", "text"],
  ["primerApellido", "identidad.primerApellido", "text"],
  ["genero", "identidad.genero", "text"],
  ["cedula", "identidad.cedula", "text"],
  ["telefono", "identidad.telefono", "text"],
  ["fechaNacimiento", "identidad.fechaNacimiento", "date"],
  ["edadDeclarada", "identidad.edadDeclarada", "number"],
  ["representanteNombre", "identidad.representante.primerNombre", "text"],
  ["representanteApellido", "identidad.representante.primerApellido", "text"],
  ["representanteCedula", "identidad.representante.cedula", "text"],
  ["lgbtqi", "identidad.lgbtqi", "text"],
  ["comunidad", "identidad.comunidad", "text"],
  ["codigoComunidad", "identidad.codigoComunidad", "text"],
  ["grupoEtnicoId", "identidad.grupoEtnicoId", "id"],
  ["discapacidadId", "identidad.discapacidadId", "id"],
  ["movilidadId", "identidad.movilidadId", "id"],
  ["factorRiesgoIds", "identidad.factorRiesgoIds", "idList"],
  ["nivelEducativoId", "identidad.nivelEducativoId", "id"],
  ["ingresos", "identidad.ingresos", "text"],
  ["cabezaFamilia", "identidad.cabezaFamilia", "text"],
  ["fechaAtencion", "atencion.fechaAtencion", "date"],
  ["estado", "atencion.estado", "text"],
  ["municipio", "atencion.municipio", "text"],
  ["parroquia", "atencion.parroquia", "text"],
  ["centro", "atencion.centro", "text"],
  ["pruebaEmbarazo", "atencion.pruebaEmbarazo", "text"],
  ["codigoMetodo", "atencion.codigoMetodo", "text"],
  ["metodoAnticonceptivo", "atencion.metodoAnticonceptivo", "text"],
  ["medicoId", "atencion.medicoId", "id"],
  ["comentarios", "atencion.comentarios", "text"],
  ["pruebaVIH", "its.pruebaVIH", "text"],
  ["pruebaSifilis", "its.pruebaSifilis", "text"],
  ["pruebaHepatitis", "its.pruebaHepatitis", "text"],
  ["codigoDiagnostico", "its.codigoDiagnostico", "text"],
  ["diagnosticoSindromatico", "its.diagnosticoSindromatico", "text"],
  ["tratamientoITS", "its.tratamientos.indicados", "treatments"],
];

export function antiConFormSnapshot({ formData, edadDeclarada, fechaAtencion, estado, municipio, parroquia, centro }) {
  const b = formData.beneficiaria;
  const r = formData.representante;
  const d = formData.demograficosBeneficiaria;
  const a = formData.atencion;
  const i = formData.manejoITS;
  return {
    codigo: b.codigo, primerNombre: b.primerNombre, primerApellido: b.primerApellido,
    genero: b.genero, cedula: b.cedulaIdentidad, telefono: b.numeroTelefonico,
    fechaNacimiento: b.fechaNacimiento, edadDeclarada,
    representanteNombre: r.primerNombre, representanteApellido: r.primerApellido,
    representanteCedula: r.cedulaIdentidad,
    lgbtqi: d.lgbtqi, comunidad: d.comunidad, codigoComunidad: d.codigoComunidad,
    grupoEtnicoId: d.codigoGrupoEtnico, discapacidadId: d.codigoDiscapacidad,
    movilidadId: d.codigoCondicionMovilidad,
    factorRiesgoIds: d.codigoFactoresRiesgo ? [d.codigoFactoresRiesgo] : [],
    nivelEducativoId: d.codigoNivelEducativo, ingresos: d.ingresosPropios,
    cabezaFamilia: d.cabezaFamilia, fechaAtencion, estado, municipio, parroquia, centro,
    pruebaEmbarazo: a.pruebaEmbarazo, codigoMetodo: a.codigoAtencion,
    metodoAnticonceptivo: a.metodoAnticonceptivo,
    medicoId: formData.adicionales.medicoResponsable?.id || "",
    comentarios: formData.adicionales.comentarios,
    pruebaVIH: i.pruebaVIH, pruebaSifilis: i.pruebaSifilis,
    pruebaHepatitis: i.pruebaHepatitis, codigoDiagnostico: i.codigoDiagnosticoITS,
    diagnosticoSindromatico: i.diagnosticoITS,
    tratamientoITS: Array.isArray(i.tratamientoITS) ? i.tratamientoITS : [],
  };
}

export function serializeFormToV2Data(snapshot, original, baseline) {
  const extra = at(original, "identidad.factorRiesgoIds")?.slice(1) || [];
  const current = { ...snapshot };
  if (baseline && String(snapshot.codigoMetodo) === String(baseline.codigoMetodo)) current.metodoAnticonceptivo = baseline.metodoAnticonceptivo;
  if (baseline && String(snapshot.codigoDiagnostico) === String(baseline.codigoDiagnostico)) current.diagnosticoSindromatico = baseline.diagnosticoSindromatico;
  return serializeMappedForm(
    { ...current, factorRiesgoIds: [...(snapshot.factorRiesgoIds || []), ...extra] }, fields, original,
    { ...baseline, factorRiesgoIds: [...(baseline?.factorRiesgoIds || []), ...extra] }
  );
}

export function hydrateV2DataToForm(datos) {
  const ui = hydrateMappedForm(datos, fields);
  const formData = {
    beneficiaria: {
      codigo: ui.codigo, primerNombre: ui.primerNombre, primerApellido: ui.primerApellido,
      genero: ui.genero, cedulaIdentidad: ui.cedula, numeroTelefonico: ui.telefono,
      fechaNacimiento: ui.fechaNacimiento,
    },
    representante: {
      primerNombre: ui.representanteNombre, primerApellido: ui.representanteApellido,
      cedulaIdentidad: ui.representanteCedula,
    },
    demograficosBeneficiaria: {
      lgbtqi: ui.lgbtqi, comunidad: ui.comunidad, codigoComunidad: ui.codigoComunidad,
      codigoGrupoEtnico: ui.grupoEtnicoId, grupoEtnico: "",
      codigoDiscapacidad: ui.discapacidadId, discapacidad: "",
      codigoCondicionMovilidad: ui.movilidadId, condicionMovilidad: "",
      codigoFactoresRiesgo: ui.factorRiesgoIds[0] || "", factoresRiesgo: "",
      codigoNivelEducativo: ui.nivelEducativoId, nivelEducativo: "",
      ingresosPropios: ui.ingresos, cabezaFamilia: ui.cabezaFamilia,
    },
    atencion: { pruebaEmbarazo: ui.pruebaEmbarazo, codigoAtencion: ui.codigoMetodo,
      metodoAnticonceptivo: ui.metodoAnticonceptivo },
    manejoITS: {
      pruebaVIH: ui.pruebaVIH, pruebaSifilis: ui.pruebaSifilis, pruebaHepatitis: ui.pruebaHepatitis,
      codigoDiagnosticoITS: ui.codigoDiagnostico, diagnosticoITS: ui.diagnosticoSindromatico,
      tratamientoITS: ui.tratamientoITS,
    },
    adicionales: { comentarios: ui.comentarios, medicoResponsable: null },
  };
  if (at(datos, "atencion.medicoId")) formData.adicionales.medicoResponsable = { id: ui.medicoId };
  return { formData, edadDeclarada: ui.edadDeclarada, fechaAtencion: ui.fechaAtencion,
    estado: ui.estado, municipio: ui.municipio, parroquia: ui.parroquia, centro: ui.centro };
}
